import { getAccountId } from 'redux/actions/accountActions'

/**
 * Creates a Room connection for the signed-in User. The "channel"
 * is the owner username, with all specials other than "_" replaced by "_".
 * This is what socket.io calls the "namespace". 
 * @param {*} room 
 * @returns /[channel]/[roomId]/[base64(userId)]
 */
export const getConnectionChannel = (room) => {
    const { channel, _id } = room
    console.log(`getConnectionChannel ${_id}`, channel)
    const { name: channelName } = channel
    const userId = getAccountId()
    const b64UserId = btoa(userId)
    return `/${channelName}/${_id}/${b64UserId}?uid=${b64UserId}`
}

/**
 * This uses the roomId and username in the Message to form the Room connection.
 * This reliease on the convention that the channel
 * the owner username, with all specials other than "_" replaced by "_" .
 * @param {*} message 
 * @returns  /[channel]/[roomId]/[base64(userId)]
 */
export const getConnectionChannelForMessage = (message) => {
    const { username, roomId } = message
    const channelName = username.replaceAll(/[^a-zA-Z0-9\s]/g, "_")
    const userId = getAccountId()
    const b64UserId = btoa(userId)
    const channel = `/${channelName}/${roomId}/${b64UserId}`
    console.log(`getConnectionChannelForMessage ${channel}`, message)
    return channel
}
